import React from "react";
import { Card, Heading } from "@caesars-ui/core";

export const Gallery = ({ items }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem', margin: '2rem 0' }}>
      {items.map((item) => (
        <Card 
          key={item.title}
          bg="bg-default" 
          rounded="md" 
          shadow="sm"
          borderColor="fg-minimal"
          className="cui-h-full hover:cui-shadow-md cui-transition-shadow cui-overflow-hidden"
          noPad
        >
          <a href={item.link} style={{ textDecoration: 'none' }}>
            {item.image && (
              <div className="cui-w-full cui-h-48 cui-bg-bg-subtle">
                <img src={item.image} alt={item.title} className="cui-w-full cui-h-full cui-object-cover" />
              </div>
            )}
          </a>
          <div style={{ padding: 'var(--spacing-md)' }}>
            <a href={item.link} style={{ textDecoration: 'none' }}>
              <Heading size="xl" className="cui-text-fg-default">{item.title}</Heading>
            </a>
            {item.description && <p className="p-small" style={{ marginTop: '0.5rem', marginBottom: '0.5rem' }}>{item.description}</p>}
          </div>
        </Card>
      ))}
    </div>
  );
};